import React from 'react';
import PaymentPanel from '../components/payment/PaymentPanel';

export default function PaymentPage() {
  return <PaymentPanel />;
}